export default "/assets/images/filter-03.2b5d851b362b6819.svg";